var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-default",attrs:{"disabled":_vm.disabled}},[(_vm.icon)?_c('font-awesome-icon',{staticClass:"fa-fw",class:{'fa-spin': _vm.spin},attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.placeholder)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }